/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { ChannelModel, ChannelModelType } from './ChannelModel'
import { ChannelModelSelector } from './ChannelModel.base'
import { GameEntityModel, GameEntityModelType } from './GameEntityModel'
import { GameEntityModelSelector } from './GameEntityModel.base'
import { RootStoreType } from './index'

/**
 * MakeGameResultBase
 * auto generated base class for the model MakeGameResultModel.
 */
export const MakeGameResultModelBase = ModelBase.named('MakeGameResult')
  .props({
    __typename: types.optional(types.literal('MakeGameResult'), 'MakeGameResult'),
    channel: types.union(
      types.undefined,
      types.late(() => ChannelModel)
    ),
    game: types.union(
      types.undefined,
      types.late(() => GameEntityModel)
    )
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class MakeGameResultModelSelector extends QueryBuilder {
  channel(
    builder: string | ChannelModelSelector | ((selector: ChannelModelSelector) => ChannelModelSelector) | undefined
  ) {
    return this.__child('channel', ChannelModelSelector, builder)
  }
  game(
    builder:
      | string
      | GameEntityModelSelector
      | ((selector: GameEntityModelSelector) => GameEntityModelSelector)
      | undefined
  ) {
    return this.__child('game', GameEntityModelSelector, builder)
  }
}
export function selectFromMakeGameResult() {
  return new MakeGameResultModelSelector()
}

export const makeGameResultModelPrimitives = selectFromMakeGameResult()
